// extracted by mini-css-extract-plugin
export default {"navbar":"NavBar_navbar__60ZL6","grey":"NavBar_grey__AE81b","offcanvas":"NavBar_offcanvas__fDRAr"};